import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { applyMeta, pageMeta } from '../seo.js';
import { EDITORIAL_ROUTES } from '../content/index.js';

const META = EDITORIAL_ROUTES.find(r => r.path === '/contact');

export const CONTACT_EMAIL = 'hello@talkmuch.org';

export default function Contact() {
  useEffect(() => applyMeta(pageMeta({
    path: '/contact',
    title: META.title,
    description: META.description,
  })), []);

  return (
    <article className="page-prose">
      <h1 className="page-heading">Contact</h1>
      <p className="page-subheading">Corrections, requests and everything else.</p>

      <p>
        Email <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>. It is read by a
        person, and messages usually get an answer within a few days.
      </p>

      <h2>Reporting a wrong number</h2>
      <p>
        The most useful thing you can send us. Include the episode link and what looks off:
        most commonly it is a host and guest swapped round, which happens when speaker
        separation puts the guest in the same cluster as the show intro. We can re-check
        those against the stored transcript at no cost, so corrections are cheap for us to
        act on. <Link to="/methodology">The methodology page</Link> explains how the
        detection works and where it breaks.
      </p>

      <h2>Asking for a podcast</h2>
      <p>
        Tell us the show and the RSS feed if you have it. Adding a podcast means writing a
        configuration for it and checking the host detection holds up across a sample of
        episodes, so it is not instant, but the queue is short.
      </p>

      <h2>Publishers and rights holders</h2>
      <p>
        If you publish a show that appears here and want something changed or removed, write
        to the same address and it will be handled promptly. We publish measurements and
        short identifying details, never full transcripts.
      </p>

      <h2>Privacy requests</h2>
      <p>
        For access, deletion or withdrawal of consent, see{' '}
        <Link to="/privacy">the privacy policy</Link>, which sets out what is stored and how
        to have it removed.
      </p>
    </article>
  );
}
